import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import WhatsAppTemplatePageUI from './WhatsAppTemplatePageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class WhatsAppTemplatePageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            templates: null,
            errorList: null,
            loading: true,
            currentPage: 0,
            totalPages: 0,
            totalElements: 0
        }
    }

    componentDidMount() {
        this.getWhatsAppTemplates(this.props.context)
    }

    getWhatsAppTemplates = (context) => {
        this.setState({ loading: true })
        
        RestApiUtils.get(
            context,
            '/api/su/whatsappTemplates/all',
            this.getWhatsAppTemplatesCallback
        )
    }

    getWhatsAppTemplatesCallback = (response) => {
        if (response.errorList && response.errorList.length > 0) {
            this.setState({
                errorList: response.errorList,
                loading: false
            })
            return
        }

        this.setState({
            templates: response.templates || [],
            currentPage: response.currentPage || 0,
            totalPages: response.totalPages || 0,
            totalElements: response.totalElements || 0,
            loading: false,
            errorList: null
        })
    }

    onRefreshClick = () => {
        this.getWhatsAppTemplates(this.props.context)
    }

    render() {
        return (
            <WhatsAppTemplatePageUI
                context={this.props.context}
                templates={this.state.templates}
                errorList={this.state.errorList}
                loading={this.state.loading}
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                totalElements={this.state.totalElements}
                onRefreshClick={this.onRefreshClick}
            />
        )
    }
}

export default withRouter(WhatsAppTemplatePageSF)
